
import React from "react";
import BTC from "./coins/BTC"
import ETH from "./coins/ETH"
import BCH from "./coins/BCH"
import LTC from "./coins/LTC"
import BSV from "./coins/BSV"
import XMR from "./coins/XMR"
import DASH from "./coins/DASH"
import ETC from "./coins/ETC"
import ZEC from "./coins/ZEC"
import BTG from "./coins/BTG"
import DOGE from "./coins/DOGE"
import DCR from "./coins/DCR"
import BTM from "./coins/BTM"
import HC from "./coins/HC"
import BCD from "./coins/BCD"
import RVN from "./coins/RVN"
import BCN from "./coins/BCN"
import ZIL from "./coins/ZIL"
import MONA from "./coins/MONA"
import AE from "./coins/AE"
import ETP from "./coins/ETP"
import DGB from "./coins/DGB"
import SC from "./coins/SC"
import KMD from "./coins/KMD"
import XVG from "./coins/XVG"
import XZC from "./coins/XZC"
import GRIN from "./coins/GRIN"
import ZEN from "./coins/ZEN"
import BEAM from "./coins/BEAM"
import ETN from "./coins/ETN"
import AION from "./coins/AION"
import HYC from "./coins/HYC"
import GRS from "./coins/GRS"
import VTC from "./coins/VTC"
import QRL from "./coins/QRL"
import EMC2 from "./coins/EMC2"
import ARRR from "./coins/ARRR"
import SMART from "./coins/SMART"
import VBK from "./coins/VBK"
import FLO from "./coins/FLO"
import BTX from "./coins/BTX"
import XDN from "./coins/XDN"
import VIA from "./coins/VIA"
import PPC from "./coins/PPC"
import UBQ from "./coins/UBQ"
import LBC from "./coins/LBC"
import ONION from "./coins/ONION"
import LCC from "./coins/LCC"
import BBR from "./coins/BBR"
import ZCL from "./coins/ZCL"
import LOKI from "./coins/LOKI"
import NLG from "./coins/NLG"
import FTC from "./coins/FTC"
import ZEL from "./coins/ZEL"
import NIM from "./coins/NIM"
import DERO from "./coins/DERO"
import GAME from "./coins/GAME"
import TUBE from "./coins/TUBE"
import HNDC from "./coins/HNDC"
import PASC from "./coins/PASC"
import TRTL from "./coins/TRTL"
import MOON from "./coins/MOON"
import QWC from "./coins/QWC"
import GRFT from "./coins/GRFT"
import LUX from "./coins/LUX"
import XMY from "./coins/XMY"
import ETNX from "./coins/ETNX"
import XHV from "./coins/XHV"
import EXP from "./coins/EXP"
import QRK from "./coins/QRK"
import $PAC from "./coins/$PAC"
import AXE from "./coins/AXE"
import VEIL from "./coins/VEIL"
import SAFE from "./coins/SAFE"
import SIN from "./coins/SIN"
import BTCP from "./coins/BTCP"
import XDAG from "./coins/XDAG"
import DIME from "./coins/DIME"
import BTH from "./coins/BTH"
import SIB from "./coins/SIB"
import MUSIC from "./coins/MUSIC"
import UFO from "./coins/UFO"
import GIN from "./coins/GIN"
import BSD from "./coins/BSD"
import ESP from "./coins/ESP"
import EFL from "./coins/EFL"
import BTCZ from "./coins/BTCZ"
import ESN from "./coins/ESN"
import UPX from "./coins/UPX"
import MSR from "./coins/MSR"
import PIRL from "./coins/PIRL"
import ZER from "./coins/ZER"
import PINK from "./coins/PINK"
import XCASH from "./coins/XCASH"
import XSG from "./coins/XSG"
import TZC from "./coins/TZC"
import SFX from "./coins/SFX"
import SAGE from "./coins/SAGE"
import RICH from "./coins/RICH"
import PHAT from "./coins/PHAT"
import SUM from "./coins/SUM"
import HULI from "./coins/HULI"
import BET from "./coins/BET"
import PYE from "./coins/PYE"
import RIVX from "./coins/RIVX"
import QPSA from "./coins/QPSA"
import CARDI from "./coins/CARDI"
import PROC from "./coins/PROC"
import RHOM from "./coins/RHOM"
import KEG from "./coins/KEG"
import LCNT from "./coins/LCNT"
import ZEXO from "./coins/ZEXO"
import BZC from "./coins/BZC"
import KMDICE from "./coins/KMDICE"
import OUR from "./coins/OUR"
import LCX from "./coins/LCX"
import VHS from "./coins/VHS"
import UCC from "./coins/UCC"
import BUEN from "./coins/BUEN"
import TRTG from "./coins/TRTG"
import XSC from "./coins/XSC"
import OSL from "./coins/OSL"
import BTCH from "./coins/BTCH"
import BTCHP from "./coins/BTCHP"
import BTCMZ from "./coins/BTCMZ"
import HITC from "./coins/HITC"
import ZYRK from "./coins/ZYRK"
import XLI from "./coins/XLI"
import ADON from "./coins/ADON"
import BTN from "./coins/BTN"
import NACA from "./coins/NACA"
import CX from "./coins/CX"
import MTIP from "./coins/MTIP"
import NAZA from "./coins/NAZA"
import LBIT from "./coins/LBIT"
import TYCH from "./coins/TYCH"
import RMX from "./coins/RMX"
import LUK from "./coins/LUK"
import HRCN from "./coins/HRCN"
import IPBC from "./coins/IPBC"
import INX from "./coins/INX"
import FED from "./coins/FED"
import SIP from "./coins/SIP"
import NINJA from "./coins/NINJA"
import XCOIN from "./coins/XCOIN"
import BXB from "./coins/BXB"
import WFX from "./coins/WFX"
import QRK2 from "./coins/QRK2"
import CCH from "./coins/CCH"
import PION from "./coins/PION"
import FNO from "./coins/FNO"
import N42 from "./coins/N42"
import TXX from "./coins/TXX"
import DRGL from "./coins/DRGL"
import HTA from "./coins/HTA"
import JYO from "./coins/JYO"
import MDEX from "./coins/MDEX"
import CAL from "./coins/CAL"
import MUTX from "./coins/MUTX"
import POLY from "./coins/POLY"
import UOU from "./coins/UOU"
import XLC from "./coins/XLC"
import LUMBER from "./coins/LUMBER"
import GEEK from "./coins/GEEK"
import DISL from "./coins/DISL"
import KPL from "./coins/KPL"
import GMC from "./coins/GMC"
import LTZ from "./coins/LTZ"
import LINC from "./coins/LINC"
import ZERC from "./coins/ZERC"
import SUN from "./coins/SUN"
import CBS from "./coins/CBS"
import JEM from "./coins/JEM"
import VRM from "./coins/VRM"
import TOUR from "./coins/TOUR"
import ALPS from "./coins/ALPS"
import FXC from "./coins/FXC"
import CXT from "./coins/CXT"
import ENCO from "./coins/ENCO"
import STM from "./coins/STM"
import BTE from "./coins/BTE"
import WOLF from "./coins/WOLF"
import TNET from "./coins/TNET"
import CRS from "./coins/CRS"
import AEVO from "./coins/AEVO"
import BOOT from "./coins/BOOT"
import ZUR from "./coins/ZUR"
import ANX from "./coins/ANX"
import V8 from "./coins/V8"
import XPTX from "./coins/XPTX"
import ZOW from "./coins/ZOW"
import XTP from "./coins/XTP"
import SUDO from "./coins/SUDO"
import COC from "./coins/COC"
import MASK from "./coins/MASK"
import MTNS from "./coins/MTNS"
import REDN from "./coins/REDN"
import ARA from "./coins/ARA"
import BTPL from "./coins/BTPL"
import TNA from "./coins/TNA"
import XEQ from "./coins/XEQ"
import KRB from "./coins/KRB"
import AUR from "./coins/AUR"
import START from "./coins/START"
import HUSH from "./coins/HUSH"
import SCP from "./coins/SCP"
import XMG from "./coins/XMG"
import ZCR from "./coins/ZCR"
import LTHN from "./coins/LTHN"
import GUN from "./coins/GUN"
import EGEM from "./coins/EGEM"
import BZE from "./coins/BZE"
import CCX from "./coins/CCX"
import WDC from "./coins/WDC"
import XWP from "./coins/XWP"
import ANON from "./coins/ANON"
import RYO from "./coins/RYO"
import EUNO from "./coins/EUNO"
import IMGC from "./coins/IMGC"
import ARO from "./coins/ARO"
import PGN from "./coins/PGN"
import GBX from "./coins/GBX"
import MNX from "./coins/MNX"
import GLT from "./coins/GLT"
import TRC from "./coins/TRC"
import PTC from "./coins/PTC"
import PLUS1 from "./coins/PLUS1"
import ZET from "./coins/ZET"
import EXO from "./coins/EXO"
import RIC from "./coins/RIC"
import SPDR from "./coins/SPDR"
import MFC from "./coins/MFC"
import LANA from "./coins/LANA"
import ARG from "./coins/ARG"
import NYAN from "./coins/NYAN"
import ACM from "./coins/ACM"
import MEC from "./coins/MEC"
import ARQ from "./coins/ARQ"
import GXX from "./coins/GXX"
import REOSC from "./coins/REOSC"
import NCP from "./coins/NCP"
import IQ from "./coins/IQ"
import DEM from "./coins/DEM"
import ARC from "./coins/ARC"
import IC from "./coins/IC"
import BTB from "./coins/BTB"
import BTCN from "./coins/BTCN"
import ORE from "./coins/ORE"
import SKC from "./coins/SKC"
import MAX from "./coins/MAX"
import LCP from "./coins/LCP"
import PRIV from "./coins/PRIV"
import KREDS from "./coins/KREDS"
import WEB from "./coins/WEB"
import XBG from "./coins/XBG"
import CPA from "./coins/CPA"
import ADZ from "./coins/ADZ"
import CROAT from "./coins/CROAT"
import BZX from "./coins/BZX"
import BRAZ from "./coins/BRAZ"
import CASH2 from "./coins/CASH2"
import ELLA from "./coins/ELLA"
import ETNXP from "./coins/ETNXP"
import XUN from "./coins/XUN"
import VLU from "./coins/VLU"
import VLS from "./coins/VLS"
import EXCC from "./coins/EXCC"
import SCRIV from "./coins/SCRIV"
import MANGA from "./coins/MANGA"
import CMPCO from "./coins/CMPCO"
import XMCC from "./coins/XMCC"
import STAK from "./coins/STAK"
import IRD from "./coins/IRD"
import PASL from "./coins/PASL"
import GENX from "./coins/GENX"
import MIX from "./coins/MIX"
import CRP from "./coins/CRP"
import LINX from "./coins/LINX"
import ABS from "./coins/ABS"
import B2N from "./coins/B2N"
import PLURA from "./coins/PLURA"
import BLOC from "./coins/BLOC"
import XSR from "./coins/XSR"
import NEET from "./coins/NEET"
import XVP from "./coins/XVP"
import X12 from "./coins/X12"
import BSM from "./coins/BSM"
import TRAID from "./coins/TRAID"
import TTNZ from "./coins/TTNZ"
import AREPA from "./coins/AREPA"
import MON from "./coins/MON"
import ARION from "./coins/ARION"
import BOLI from "./coins/BOLI"
import BUCK from "./coins/BUCK"
import CTL from "./coins/CTL"
import BTA from "./coins/BTA"
import LBTC from "./coins/LBTC"
import BRIX from "./coins/BRIX"
import XDNA from "./coins/XDNA"
import YTN from "./coins/YTN"
import NEVA from "./coins/NEVA"
import DIN from "./coins/DIN"
import DVT from "./coins/DVT"
import INFO from "./coins/INFO"
import INTU from "./coins/INTU"
import INFX from "./coins/INFX"
import ZOC from "./coins/ZOC"
import MAC from "./coins/MAC"
import TUX from "./coins/TUX"
import RTO from "./coins/RTO"
import NBX from "./coins/NBX"
import VECO from "./coins/VECO"
import HLX from "./coins/HLX"
import ONX from "./coins/ONX"
import BTCV from "./coins/BTCV"
import BZL from "./coins/BZL"
import GWAY from "./coins/GWAY"
import ATH from "./coins/ATH"
import XGCS from "./coins/XGCS"
import TAJ from "./coins/TAJ"
import MKT from "./coins/MKT"
import XTA from "./coins/XTA"
import GENIX from "./coins/GENIX"
import BKC from "./coins/BKC"
import TSF from "./coins/TSF"
import DVS from "./coins/DVS"
import BOLD from "./coins/BOLD"
import EMRALS from "./coins/EMRALS"
import XMN from "./coins/XMN"
import QBS from "./coins/QBS"
import FLM from "./coins/FLM"
import URALS from "./coins/URALS"
import MOG from "./coins/MOG"
import ZTC from "./coins/ZTC"
import XZX from "./coins/XZX"
import MYNT from "./coins/MYNT"
import DAC from "./coins/DAC"
import ARMS from "./coins/ARMS"
import STONE from "./coins/STONE"
import MBGL from "./coins/MBGL"
import AQUA from "./coins/AQUA"
import XRE from "./coins/XRE"
import CRCL from "./coins/CRCL"
import NYX from "./coins/NYX"
import VIOG from "./coins/VIOG"
import GEEM from "./coins/GEEM"
import COPPER from "./coins/COPPER"
import VECT from "./coins/VECT"
import TIMEC from "./coins/TIMEC"
import ITZ from "./coins/ITZ"
import PCOIN from "./coins/PCOIN"
import LUCKY from "./coins/LUCKY"
import WAVI from "./coins/WAVI"
import PARS from "./coins/PARS"
import XJO from "./coins/XJO"
import INVC from "./coins/INVC"
import XNB from "./coins/XNB"
import FTO from "./coins/FTO"
import BTOR from "./coins/BTOR"
import XLA from "./coins/XLA"
import VGC from "./coins/VGC"
import DCY from "./coins/DCY"
import SPLB from "./coins/SPLB"
import VIVO from "./coins/VIVO"
import DSR from "./coins/DSR"
import STG from "./coins/STG"
import HAL from "./coins/HAL"
import RAP from "./coins/RAP"
import MBC from "./coins/MBC"
import ORB from "./coins/ORB"
import SPK from "./coins/SPK"
import TUN from "./coins/TUN"
import XMC from "./coins/XMC"
import STL from "./coins/STL"
import PXC from "./coins/PXC"
import SCSX from "./coins/SCSX"
import POWN from "./coins/POWN"
import MOC from "./coins/MOC"
import SAGA from "./coins/SAGA"
import SUMO from "./coins/SUMO"
import XMV from "./coins/XMV"
import PURA from "./coins/PURA"
import SUP from "./coins/SUP"
import PLE from "./coins/PLE"
import FRED from "./coins/FRED"
import CANN from "./coins/CANN"
import HTH from "./coins/HTH"
import B2B from "./coins/B2B"
import ELPH from "./coins/ELPH"
import GRV from "./coins/GRV"
import SOV from "./coins/SOV"
import PHL from "./coins/PHL"
import HDN from "./coins/HDN"
import XCY from "./coins/XCY"
import WRKZ from "./coins/WRKZ"
import WTIP from "./coins/WTIP"
import XRD from "./coins/XRD"
import DEGO from "./coins/DEGO"
import XSH from "./coins/XSH"
import NVC from "./coins/NVC"
import BITC from "./coins/BITC"
import OMEGA from "./coins/OMEGA"
import GLC from "./coins/GLC"
import XCG from "./coins/XCG"
import XCQ from "./coins/XCQ"
import PYX from "./coins/PYX"
import ETFX from "./coins/ETFX"
import BALLZ from "./coins/BALLZ"
import RFOX from "./coins/RFOX"
import VOT from "./coins/VOT"
import PRKL from "./coins/PRKL"
import XTNC from "./coins/XTNC"
import RITO from "./coins/RITO"
import RPG from "./coins/RPG"
import ETI from "./coins/ETI"
import CMM from "./coins/CMM"
import DOGX from "./coins/DOGX"
import RACE from "./coins/RACE"
import AZART from "./coins/AZART"
import B2G from "./coins/B2G"
import PGC from "./coins/PGC"
import WXC from "./coins/WXC"
import SAP from "./coins/SAP"
import XRC from "./coins/XRC"
import VIC from "./coins/VIC"
import NTBC from "./coins/NTBC"
import BCX from "./coins/BCX"
import VLC from "./coins/VLC"
import HELP from "./coins/HELP"
import NUKO from "./coins/NUKO"
import NILU from "./coins/NILU"
import MARS from "./coins/MARS"
import HDAC from "./coins/HDAC"
import C25 from "./coins/C25"
import XAO from "./coins/XAO"
import GRLC from "./coins/GRLC"
import NAH from "./coins/NAH"
import D from "./coins/D"
import AYA from "./coins/AYA"
import FURY from "./coins/FURY"
import ETHO from "./coins/ETHO"
import SCC from "./coins/SCC"
import MOAC from "./coins/MOAC"
import AGM from "./coins/AGM"
import SLC from "./coins/SLC"
import CRM from "./coins/CRM"
import GEX from "./coins/GEX"
import SRC from "./coins/SRC"
import WHL from "./coins/WHL"
import LTNCG from "./coins/LTNCG"
import BHD from "./coins/BHD"
import CLO from "./coins/CLO"
import MOX from "./coins/MOX"
import ZLS from "./coins/ZLS"
import UIS from "./coins/UIS"
import VEGI from "./coins/VEGI"
import BTCBZ from "./coins/BTCBZ"
import ZEON from "./coins/ZEON"
import AKA from "./coins/AKA"
import VDL from "./coins/VDL"
import VIRIDI from "./coins/VIRIDI"
import ADV2 from "./coins/ADV2"
import HANA from "./coins/HANA"
import FORK from "./coins/FORK"
import BSTY from "./coins/BSTY"
import ZNY from "./coins/ZNY"
import KOTO from "./coins/KOTO"
import BCI from "./coins/BCI"
import DBIX from "./coins/DBIX"
import YOC from "./coins/YOC"
import OMB from "./coins/OMB"
import SOLACE from "./coins/SOLACE"
import ZANO from "./coins/ZANO"
import HORA from "./coins/HORA"
import SERO from "./coins/SERO"
import TLR from "./coins/TLR"
import IFX from "./coins/IFX"
import AUS from "./coins/AUS"
import XBA from "./coins/XBA"
import SUSU from "./coins/SUSU"
import UBTC from "./coins/UBTC"
import BCA from "./coins/BCA"
import MNC from "./coins/MNC"
import VRSC from "./coins/VRSC"
import VEO from "./coins/VEO"
import SBTC from "./coins/SBTC"
import WOW from "./coins/WOW"
import NSD from "./coins/NSD"
import SONO from "./coins/SONO"
import RNG from "./coins/RNG"
import DEFT from "./coins/DEFT"
import BLAST from "./coins/BLAST"
import NBR from "./coins/NBR"
import PRD from "./coins/PRD"
import ABY from "./coins/ABY"
import TFTN from "./coins/TFTN"
import KRONE from "./coins/KRONE"
import BMN from "./coins/BMN"
import TEO from "./coins/TEO"
import MCN from "./coins/MCN"
import BNODE from "./coins/BNODE"
import SPES from "./coins/SPES"
import AEON from "./coins/AEON"
import ELI from "./coins/ELI"
import KUMA from "./coins/KUMA"
import LTFN from "./coins/LTFN"
import BBS from "./coins/BBS"
import CDY from "./coins/CDY"
import BELL from "./coins/BELL"
import DYN from "./coins/DYN"
import ZMY from "./coins/ZMY"
import URX from "./coins/URX"
import INN from "./coins/INN"
import HPC from "./coins/HPC"
import XGK from "./coins/XGK"
import HWI from "./coins/HWI"
import TMC from "./coins/TMC"
import HOSP from "./coins/HOSP"
import YEC from "./coins/YEC"
import BLC from "./coins/BLC"
import XVT from "./coins/XVT"
import TRAGO from "./coins/TRAGO"
import ARW from "./coins/ARW"
import FXTC from "./coins/FXTC"
import HATCH from "./coins/HATCH"
import IDC from "./coins/IDC"
import IRL from "./coins/IRL"
import EBG from "./coins/EBG"
import DGC from "./coins/DGC"
import CMT from "./coins/CMT"
import CHEESE from "./coins/CHEESE"
import CAGE from "./coins/CAGE"
import MARKS from "./coins/MARKS"
import BTLC from "./coins/BTLC"
import BTCV16 from "./coins/BTCV16"
import BTCHD from "./coins/BTCHD"
import BAD from "./coins/BAD"
import KURO from "./coins/KURO"
import LEVO from "./coins/LEVO"
import MZC from "./coins/MZC"
import MHSP from "./coins/MHSP"
import MOTA from "./coins/MOTA"
import NACHO from "./coins/NACHO"
import PEXA from "./coins/PEXA"
import SONG from "./coins/SONG"
import SPP from "./coins/SPP"
import UTIP from "./coins/UTIP"
import COQUI from "./coins/COQUI"
import DEI from "./coins/DEI"
import PARTY from "./coins/PARTY"
import THOR from "./coins/THOR"
import XPD from "./coins/XPD"
import CROC from "./coins/CROC"
import EMC from "./coins/EMC"
import CML from "./coins/CML"
import RAT from "./coins/RAT"
import AEX from "./coins/AEX"
import MGD from "./coins/MGD"
import X0Z from "./coins/X0Z"
import LEV from "./coins/LEV"
import BTCS from "./coins/BTCS"
import VVX from "./coins/VVX"
import XFOX from "./coins/XFOX"
import SPKY from "./coins/SPKY"
import WFF from "./coins/WFF"
import DRC from "./coins/DRC"
import CRYP from "./coins/CRYP"
import CREP from "./coins/CREP"
import BSHA3 from "./coins/BSHA3"
import CPU from "./coins/CPU"
import MIC from "./coins/MIC"
import RC from "./coins/RC"
import TRVC from "./coins/TRVC"
import ADE from "./coins/ADE"
import LTB from "./coins/LTB"
import ANDES from "./coins/ANDES"
import DSC from "./coins/DSC"
import GRIMM from "./coins/GRIMM"
import ANDS from "./coins/ANDS"
import BIN from "./coins/BIN"
import BXT from "./coins/BXT"
import CHIPS from "./coins/CHIPS"
import IMG from "./coins/IMG"
import XTRI from "./coins/XTRI"
import INF8 from "./coins/INF8"
import TLRM from "./coins/TLRM"
import DPR from "./coins/DPR"
import ACP from "./coins/ACP"
import DUO from "./coins/DUO"
import LOG from "./coins/LOG"
import MXT from "./coins/MXT"
import OCP from "./coins/OCP"
import RABBIT from "./coins/RABBIT"
import RUBIT from "./coins/RUBIT"
import SAROS from "./coins/SAROS"
import TROLL from "./coins/TROLL"
import XSPC from "./coins/XSPC"
import ALEX from "./coins/ALEX"
import BST from "./coins/BST"
import EQT from "./coins/EQT"
import J from "./coins/J"
import AIB from "./coins/AIB"
import BOB from "./coins/BOB"
import CDN from "./coins/CDN"
import EMD from "./coins/EMD"
import FJC from "./coins/FJC"
import FLT from "./coins/FLT"
import QTL from "./coins/QTL"
import CHC from "./coins/CHC"
import NMC from "./coins/NMC"
import WXTC from "./coins/WXTC"
import DMS from "./coins/DMS"
import BBP from "./coins/BBP"
import CKB from "./coins/CKB"
import AGNT from "./coins/AGNT"
import NXS from "./coins/NXS"
import SIPC from "./coins/SIPC"
import SCRIBE from "./coins/SCRIBE"
import FUNC from "./coins/FUNC"
import VCASH from "./coins/VCASH"
import ELA from "./coins/ELA"
import SYS from "./coins/SYS"
import FCH from "./coins/FCH"
import CTXC from "./coins/CTXC"
import VOLLAR from "./coins/VOLLAR"
import HNS from "./coins/HNS"
import PMEER from "./coins/PMEER"

const LogoLoader = props => {
  const { coin } = props;
	const abbreviation = coin.abbreviation.toLowerCase();

  
  if (abbreviation === "btc") {
    return <BTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "eth") {
    return <ETH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bch") {
    return <BCH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ltc") {
    return <LTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bsv") {
    return <BSV title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xmr") {
    return <XMR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dash") {
    return <DASH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "etc") {
    return <ETC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zec") {
    return <ZEC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btg") {
    return <BTG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "doge") {
    return <DOGE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dcr") {
    return <DCR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btm") {
    return <BTM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hc") {
    return <HC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bcd") {
    return <BCD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rvn") {
    return <RVN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bcn") {
    return <BCN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zil") {
    return <ZIL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mona") {
    return <MONA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ae") {
    return <AE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "etp") {
    return <ETP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dgb") {
    return <DGB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sc") {
    return <SC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "kmd") {
    return <KMD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xvg") {
    return <XVG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xzc") {
    return <XZC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "grin") {
    return <GRIN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zen") {
    return <ZEN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "beam") {
    return <BEAM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "etn") {
    return <ETN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aion") {
    return <AION title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hyc") {
    return <HYC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "grs") {
    return <GRS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vtc") {
    return <VTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "qrl") {
    return <QRL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "emc2") {
    return <EMC2 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "arrr") {
    return <ARRR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "smart") {
    return <SMART title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vbk") {
    return <VBK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "flo") {
    return <FLO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btx") {
    return <BTX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xdn") {
    return <XDN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "via") {
    return <VIA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ppc") {
    return <PPC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ubq") {
    return <UBQ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lbc") {
    return <LBC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "onion") {
    return <ONION title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lcc") {
    return <LCC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bbr") {
    return <BBR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zcl") {
    return <ZCL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "loki") {
    return <LOKI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nlg") {
    return <NLG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ftc") {
    return <FTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zel") {
    return <ZEL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nim") {
    return <NIM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dero") {
    return <DERO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "game") {
    return <GAME title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tube") {
    return <TUBE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hndc") {
    return <HNDC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pasc") {
    return <PASC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "trtl") {
    return <TRTL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "moon") {
    return <MOON title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "qwc") {
    return <QWC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "grft") {
    return <GRFT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lux") {
    return <LUX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xmy") {
    return <XMY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "etnx") {
    return <ETNX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xhv") {
    return <XHV title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "exp") {
    return <EXP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "qrk") {
    return <QRK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "$pac") {
    return <$PAC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "axe") {
    return <AXE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "veil") {
    return <VEIL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "safe") {
    return <SAFE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sin") {
    return <SIN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btcp") {
    return <BTCP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xdag") {
    return <XDAG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dime") {
    return <DIME title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bth") {
    return <BTH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sib") {
    return <SIB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "music") {
    return <MUSIC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ufo") {
    return <UFO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "gin") {
    return <GIN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bsd") {
    return <BSD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "esp") {
    return <ESP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "efl") {
    return <EFL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btcz") {
    return <BTCZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "esn") {
    return <ESN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "upx") {
    return <UPX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "msr") {
    return <MSR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pirl") {
    return <PIRL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zer") {
    return <ZER title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pink") {
    return <PINK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xcash") {
    return <XCASH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xsg") {
    return <XSG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tzc") {
    return <TZC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sfx") {
    return <SFX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sage") {
    return <SAGE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rich") {
    return <RICH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "phat") {
    return <PHAT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sum") {
    return <SUM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "huli") {
    return <HULI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bet") {
    return <BET title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pye") {
    return <PYE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rivx") {
    return <RIVX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "qpsa") {
    return <QPSA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cardi") {
    return <CARDI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "proc") {
    return <PROC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rhom") {
    return <RHOM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "keg") {
    return <KEG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lcnt") {
    return <LCNT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zexo") {
    return <ZEXO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bzc") {
    return <BZC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "kmdice") {
    return <KMDICE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "our") {
    return <OUR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lcx") {
    return <LCX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vhs") {
    return <VHS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ucc") {
    return <UCC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "buen") {
    return <BUEN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "trtg") {
    return <TRTG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xsc") {
    return <XSC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "osl") {
    return <OSL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btch") {
    return <BTCH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btchp") {
    return <BTCHP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btcmz") {
    return <BTCMZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hitc") {
    return <HITC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zyrk") {
    return <ZYRK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xli") {
    return <XLI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "adon") {
    return <ADON title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btn") {
    return <BTN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "naca") {
    return <NACA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cx") {
    return <CX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mtip") {
    return <MTIP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "naza") {
    return <NAZA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lbit") {
    return <LBIT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tych") {
    return <TYCH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rmx") {
    return <RMX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "luk") {
    return <LUK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hrcn") {
    return <HRCN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ipbc") {
    return <IPBC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "inx") {
    return <INX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fed") {
    return <FED title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sip") {
    return <SIP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ninja") {
    return <NINJA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xcoin") {
    return <XCOIN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bxb") {
    return <BXB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wfx") {
    return <WFX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "qrk2") {
    return <QRK2 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cch") {
    return <CCH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pion") {
    return <PION title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fno") {
    return <FNO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "N42") {
    return <N42 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "txx") {
    return <TXX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "drgl") {
    return <DRGL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hta") {
    return <HTA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "jyo") {
    return <JYO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mdex") {
    return <MDEX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cal") {
    return <CAL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mutx") {
    return <MUTX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "poly") {
    return <POLY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "uou") {
    return <UOU title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xlc") {
    return <XLC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lumber") {
    return <LUMBER title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "geek") {
    return <GEEK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "disl") {
    return <DISL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "kpl") {
    return <KPL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "gmc") {
    return <GMC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ltz") {
    return <LTZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "linc") {
    return <LINC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zerc") {
    return <ZERC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sun") {
    return <SUN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cbs") {
    return <CBS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "jem") {
    return <JEM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vrm") {
    return <VRM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tour") {
    return <TOUR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "alps") {
    return <ALPS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fxc") {
    return <FXC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cxt") {
    return <CXT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "enco") {
    return <ENCO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "stm") {
    return <STM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bte") {
    return <BTE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wolf") {
    return <WOLF title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tnet") {
    return <TNET title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "crs") {
    return <CRS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aevo") {
    return <AEVO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "boot") {
    return <BOOT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zur") {
    return <ZUR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "anx") {
    return <ANX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "v8") {
    return <V8 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xptx") {
    return <XPTX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zow") {
    return <ZOW title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xtp") {
    return <XTP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sudo") {
    return <SUDO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "coc") {
    return <COC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mask") {
    return <MASK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mtns") {
    return <MTNS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "redn") {
    return <REDN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ara") {
    return <ARA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btpl") {
    return <BTPL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tna") {
    return <TNA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xeq") {
    return <XEQ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "krb") {
    return <KRB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aur") {
    return <AUR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "start") {
    return <START title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hush") {
    return <HUSH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "scp") {
    return <SCP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xmg") {
    return <XMG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zcr") {
    return <ZCR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lthn") {
    return <LTHN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "gun") {
    return <GUN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "egem") {
    return <EGEM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bze") {
    return <BZE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ccx") {
    return <CCX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wdc") {
    return <WDC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xwp") {
    return <XWP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "anon") {
    return <ANON title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ryo") {
    return <RYO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "euno") {
    return <EUNO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "imgc") {
    return <IMGC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aro") {
    return <ARO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pgn") {
    return <PGN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "gbx") {
    return <GBX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mnx") {
    return <MNX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "glt") {
    return <GLT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "trc") {
    return <TRC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ptc") {
    return <PTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "plus1") {
    return <PLUS1 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zet") {
    return <ZET title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "exo") {
    return <EXO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ric") {
    return <RIC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "spdr") {
    return <SPDR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mfc") {
    return <MFC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lana") {
    return <LANA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "arg") {
    return <ARG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nyan") {
    return <NYAN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "acm") {
    return <ACM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mec") {
    return <MEC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "arq") {
    return <ARQ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "gxx") {
    return <GXX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "reosc") {
    return <REOSC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ncp") {
    return <NCP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "iq") {
    return <IQ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dem") {
    return <DEM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "arc") {
    return <ARC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ic") {
    return <IC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btb") {
    return <BTB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btcn") {
    return <BTCN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ore") {
    return <ORE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "skc") {
    return <SKC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "max") {
    return <MAX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lcp") {
    return <LCP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "priv") {
    return <PRIV title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "kreds") {
    return <KREDS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "web") {
    return <WEB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xbg") {
    return <XBG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cpa") {
    return <CPA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "adz") {
    return <ADZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "croat") {
    return <CROAT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bzx") {
    return <BZX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "braz") {
    return <BRAZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cash2") {
    return <CASH2 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ella") {
    return <ELLA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "etnxp") {
    return <ETNXP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xun") {
    return <XUN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vlu") {
    return <VLU title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vls") {
    return <VLS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "excc") {
    return <EXCC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "scriv") {
    return <SCRIV title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "manga") {
    return <MANGA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cmpco") {
    return <CMPCO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xmcc") {
    return <XMCC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "stak") {
    return <STAK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ird") {
    return <IRD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pasl") {
    return <PASL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "genx") {
    return <GENX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mix") {
    return <MIX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "crp") {
    return <CRP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "linx") {
    return <LINX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "abs") {
    return <ABS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "b2n") {
    return <B2N title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "plura") {
    return <PLURA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bloc") {
    return <BLOC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xsr") {
    return <XSR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "neet") {
    return <NEET title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xvp") {
    return <XVP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "x12") {
    return <X12 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bsm") {
    return <BSM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "traid") {
    return <TRAID title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ttnz") {
    return <TTNZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "arepa") {
    return <AREPA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mon") {
    return <MON title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "arion") {
    return <ARION title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "boli") {
    return <BOLI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "buck") {
    return <BUCK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ctl") {
    return <CTL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bta") {
    return <BTA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lbtc") {
    return <LBTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "brix") {
    return <BRIX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xdna") {
    return <XDNA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ytn") {
    return <YTN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "neva") {
    return <NEVA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "din") {
    return <DIN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dvt") {
    return <DVT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "info") {
    return <INFO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "intu") {
    return <INTU title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "infx") {
    return <INFX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zoc") {
    return <ZOC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mac") {
    return <MAC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tux") {
    return <TUX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rto") {
    return <RTO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nbx") {
    return <NBX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "veco") {
    return <VECO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hlx") {
    return <HLX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "onx") {
    return <ONX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btcv") {
    return <BTCV title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bzl") {
    return <BZL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "gway") {
    return <GWAY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ath") {
    return <ATH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xgcs") {
    return <XGCS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "taj") {
    return <TAJ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mkt") {
    return <MKT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xta") {
    return <XTA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "genix") {
    return <GENIX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bkc") {
    return <BKC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tsf") {
    return <TSF title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dvs") {
    return <DVS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bold") {
    return <BOLD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "emrals") {
    return <EMRALS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xmn") {
    return <XMN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "qbs") {
    return <QBS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "flm") {
    return <FLM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "urals") {
    return <URALS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mog") {
    return <MOG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ztc") {
    return <ZTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xzx") {
    return <XZX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mynt") {
    return <MYNT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dac") {
    return <DAC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "arms") {
    return <ARMS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "stone") {
    return <STONE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mbgl") {
    return <MBGL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aqua") {
    return <AQUA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xre") {
    return <XRE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "crcl") {
    return <CRCL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nyx") {
    return <NYX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "viog") {
    return <VIOG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "geem") {
    return <GEEM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "copper") {
    return <COPPER title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vect") {
    return <VECT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "timec") {
    return <TIMEC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "itz") {
    return <ITZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pcoin") {
    return <PCOIN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lucky") {
    return <LUCKY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wavi") {
    return <WAVI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pars") {
    return <PARS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xjo") {
    return <XJO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "invc") {
    return <INVC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xnb") {
    return <XNB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fto") {
    return <FTO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btor") {
    return <BTOR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xla") {
    return <XLA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vgc") {
    return <VGC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dcy") {
    return <DCY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "splb") {
    return <SPLB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vivo") {
    return <VIVO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dsr") {
    return <DSR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "stg") {
    return <STG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hal") {
    return <HAL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rap") {
    return <RAP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mbc") {
    return <MBC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "orb") {
    return <ORB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "spk") {
    return <SPK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tun") {
    return <TUN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xmc") {
    return <XMC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "stl") {
    return <STL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pxc") {
    return <PXC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "scsx") {
    return <SCSX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pown") {
    return <POWN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "moc") {
    return <MOC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "saga") {
    return <SAGA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sumo") {
    return <SUMO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xmv") {
    return <XMV title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pura") {
    return <PURA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sup") {
    return <SUP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ple") {
    return <PLE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fred") {
    return <FRED title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cann") {
    return <CANN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hth") {
    return <HTH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "b2b") {
    return <B2B title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "elph") {
    return <ELPH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "grv") {
    return <GRV title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sov") {
    return <SOV title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "phl") {
    return <PHL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hdn") {
    return <HDN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xcy") {
    return <XCY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wrkz") {
    return <WRKZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wtip") {
    return <WTIP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xrd") {
    return <XRD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dego") {
    return <DEGO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xsh") {
    return <XSH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nvc") {
    return <NVC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bitc") {
    return <BITC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "omega") {
    return <OMEGA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "glc") {
    return <GLC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xcg") {
    return <XCG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xcq") {
    return <XCQ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pyx") {
    return <PYX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "etfx") {
    return <ETFX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ballz") {
    return <BALLZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rfox") {
    return <RFOX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vot") {
    return <VOT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "prkl") {
    return <PRKL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xtnc") {
    return <XTNC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rito") {
    return <RITO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rpg") {
    return <RPG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "eti") {
    return <ETI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cmm") {
    return <CMM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dogx") {
    return <DOGX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "race") {
    return <RACE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "azart") {
    return <AZART title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "b2g") {
    return <B2G title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pgc") {
    return <PGC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wxc") {
    return <WXC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sap") {
    return <SAP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xrc") {
    return <XRC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vic") {
    return <VIC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ntbc") {
    return <NTBC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bcx") {
    return <BCX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vlc") {
    return <VLC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "help") {
    return <HELP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nuko") {
    return <NUKO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nilu") {
    return <NILU title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mars") {
    return <MARS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hdac") {
    return <HDAC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "c25") {
    return <C25 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xao") {
    return <XAO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "grlc") {
    return <GRLC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nah") {
    return <NAH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "d") {
    return <D title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aya") {
    return <AYA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fury") {
    return <FURY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "etho") {
    return <ETHO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "scc") {
    return <SCC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "moac") {
    return <MOAC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "agm") {
    return <AGM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "slc") {
    return <SLC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "crm") {
    return <CRM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "gex") {
    return <GEX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "src") {
    return <SRC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "whl") {
    return <WHL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ltncg") {
    return <LTNCG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bhd") {
    return <BHD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "clo") {
    return <CLO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mox") {
    return <MOX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zls") {
    return <ZLS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "uis") {
    return <UIS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vegi") {
    return <VEGI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btcbz") {
    return <BTCBZ title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zeon") {
    return <ZEON title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aka") {
    return <AKA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vdl") {
    return <VDL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "viridi") {
    return <VIRIDI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "adv2") {
    return <ADV2 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hana") {
    return <HANA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fork") {
    return <FORK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bsty") {
    return <BSTY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zny") {
    return <ZNY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "koto") {
    return <KOTO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bci") {
    return <BCI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dbix") {
    return <DBIX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "yoc") {
    return <YOC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "omb") {
    return <OMB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "solace") {
    return <SOLACE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zano") {
    return <ZANO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hora") {
    return <HORA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sero") {
    return <SERO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tlr") {
    return <TLR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ifx") {
    return <IFX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aus") {
    return <AUS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xba") {
    return <XBA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "susu") {
    return <SUSU title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ubtc") {
    return <UBTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bca") {
    return <BCA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mnc") {
    return <MNC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vrsc") {
    return <VRSC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "veo") {
    return <VEO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sbtc") {
    return <SBTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wow") {
    return <WOW title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nsd") {
    return <NSD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sono") {
    return <SONO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rng") {
    return <RNG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "deft") {
    return <DEFT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "blast") {
    return <BLAST title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nbr") {
    return <NBR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "prd") {
    return <PRD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aby") {
    return <ABY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tftn") {
    return <TFTN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "krone") {
    return <KRONE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bmn") {
    return <BMN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "teo") {
    return <TEO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mcn") {
    return <MCN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bnode") {
    return <BNODE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "spes") {
    return <SPES title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aeon") {
    return <AEON title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "eli") {
    return <ELI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "kuma") {
    return <KUMA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ltfn") {
    return <LTFN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bbs") {
    return <BBS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cdy") {
    return <CDY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bell") {
    return <BELL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dyn") {
    return <DYN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "zmy") {
    return <ZMY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "urx") {
    return <URX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "inn") {
    return <INN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hpc") {
    return <HPC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xgk") {
    return <XGK title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hwi") {
    return <HWI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tmc") {
    return <TMC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hosp") {
    return <HOSP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "yec") {
    return <YEC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "blc") {
    return <BLC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xvt") {
    return <XVT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "trago") {
    return <TRAGO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "arw") {
    return <ARW title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fxtc") {
    return <FXTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hatch") {
    return <HATCH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "idc") {
    return <IDC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "irl") {
    return <IRL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ebg") {
    return <EBG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dgc") {
    return <DGC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cmt") {
    return <CMT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cheese") {
    return <CHEESE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cage") {
    return <CAGE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "marks") {
    return <MARKS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btlc") {
    return <BTLC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btcv16") {
    return <BTCV16 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btchd") {
    return <BTCHD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bad") {
    return <BAD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "kuro") {
    return <KURO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "levo") {
    return <LEVO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mzc") {
    return <MZC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mhsp") {
    return <MHSP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mota") {
    return <MOTA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nacho") {
    return <NACHO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pexa") {
    return <PEXA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "song") {
    return <SONG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "spp") {
    return <SPP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "utip") {
    return <UTIP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "coqui") {
    return <COQUI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dei") {
    return <DEI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "party") {
    return <PARTY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "thor") {
    return <THOR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xpd") {
    return <XPD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "croc") {
    return <CROC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "emc") {
    return <EMC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cml") {
    return <CML title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rat") {
    return <RAT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aex") {
    return <AEX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mgd") {
    return <MGD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "x0z") {
    return <X0Z title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "lev") {
    return <LEV title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "btcs") {
    return <BTCS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vvx") {
    return <VVX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xfox") {
    return <XFOX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "spky") {
    return <SPKY title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wff") {
    return <WFF title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "drc") {
    return <DRC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cryp") {
    return <CRYP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "crep") {
    return <CREP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bsha3") {
    return <BSHA3 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cpu") {
    return <CPU title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mic") {
    return <MIC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rc") {
    return <RC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "trvc") {
    return <TRVC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ade") {
    return <ADE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ltb") {
    return <LTB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "andes") {
    return <ANDES title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dsc") {
    return <DSC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "grimm") {
    return <GRIMM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ands") {
    return <ANDS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bin") {
    return <BIN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bxt") {
    return <BXT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "chips") {
    return <CHIPS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "img") {
    return <IMG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xtri") {
    return <XTRI title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "inf8") {
    return <INF8 title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "tlrm") {
    return <TLRM title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dpr") {
    return <DPR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "acp") {
    return <ACP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "duo") {
    return <DUO title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "log") {
    return <LOG title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "mxt") {
    return <MXT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ocp") {
    return <OCP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rabbit") {
    return <RABBIT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "rubit") {
    return <RUBIT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "saros") {
    return <SAROS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "troll") {
    return <TROLL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "xspc") {
    return <XSPC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "alex") {
    return <ALEX title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bst") {
    return <BST title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "eqt") {
    return <EQT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "j") {
    return <J title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "aib") {
    return <AIB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bob") {
    return <BOB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "cdn") {
    return <CDN title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "emd") {
    return <EMD title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fjc") {
    return <FJC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "flt") {
    return <FLT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "qtl") {
    return <QTL title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "chc") {
    return <CHC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nmc") {
    return <NMC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "wxtc") {
    return <WXTC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "dms") {
    return <DMS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "bbp") {
    return <BBP title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ckb") {
    return <CKB title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "agnt") {
    return <AGNT title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "nxs") {
    return <NXS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sipc") {
    return <SIPC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "scribe") {
    return <SCRIBE title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "func") {
    return <FUNC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vcash") {
    return <VCASH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ela") {
    return <ELA title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "sys") {
    return <SYS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "fch") {
    return <FCH title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "ctxc") {
    return <CTXC title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "vollar") {
    return <VOLLAR title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "hnx") {
    return <HNS title={props.title} alt={props.alt} style={props.style} />;
  } else if (abbreviation === "pmeer") {
    return <PMEER title={props.title} alt={props.alt} style={props.style} />;
  } else {
    return (
      <img
        src={`https://wheretomine.io/assets/images/logos/coins/${abbreviation}.png`}
        alt={`${coin.name} (${coin.abbreviation}) Logo`}
        width="28"
        height="28"
       />
)}

};

export default LogoLoader;
  